import { SnackBarMessage } from '../types/SnackBarMessage'

export const displaySnackBar = (data: SnackBarMessage) => {
  return {
    type: 'DISPLAY_SNACK_BAR',
    payload: data,
  }
}
